export const formatDuration = (
  duration: number | string | null | undefined
): string => {
  const durationInMinutes = Number(duration)

  if (!Number.isFinite(durationInMinutes) || durationInMinutes <= 0) {
    return ''
  }

  const hours = Math.floor(durationInMinutes / 60)
  const minutes = durationInMinutes % 60

  const hourText = hours > 0 ? `${hours} hr` : ''
  const minuteText = minutes > 0 ? `${minutes} min` : ''
  return `${hourText} ${minuteText}`.trim()
}
